export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const USER_MENU_DETAILS_REQUEST = 'USER_MENU_DETAILS_REQUEST';
export const USER_MENU_DETAILS_SUCCESS = 'USER_MENU_DETAILS_SUCCESS';
export const USER_MENU_DETAILS_FAILURE = 'USER_MENU_DETAILS_FAILURE';

export const SET_UNIT_DETAILS = "SET_UNIT_DETAILS"

export const NOTIFICATION_REQUEST = "NOTIFICATION_REQUEST";
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_FAILURE = "NOTIFICATION_FAILURE";

export const REFRESH_SESSION = "REFRESH_SESSION";
export const REFRESH_SESSION_SUCCESS = "REFRESH_SESSION_SUCCESS";
export const REFRESH_SESSION_FAILURE = "REFRESH_SESSION_FAILURE";